import { dataBold } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBold = /*#__PURE__*/createIcon(dataBold)
export default IconBold
